import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import NProgress from 'nprogress';
import { createStructuredSelector } from 'reselect';

import { makeSelectBrowser, makeSelectGlobalData } from './selectors';

const AppWrapper = styled.div`
  position: relative;
  height: 100%;
  min-height: max(100vh, 100%);
`;

export const App = (props) => {
  if (props.global.loading) {
    NProgress.start();
  } else {
    NProgress.done();
  }
  const context = {
    browser: props.browser,
    global: props.global,
    onLoadData: props.onLoadData
  };
  const children = {
    ...props.children,
    props: { ...props.children.props, ...context }
  };

  return <AppWrapper>{React.Children.toArray(children)}</AppWrapper>;
};

App.propTypes = {
  children: PropTypes.node
};

App.defaultProps = {
  children: null
};

const mapStateToProps = () =>
  createStructuredSelector({
    browser: makeSelectBrowser(),
    global: makeSelectGlobalData()
  });

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadData: (name, query = '') => {
      dispatch({ type: 'FETCH_REQUEST', payload: { name, query } });
    },
    onSend: (name, data = null, query = '') => {
      if (name) {
        dispatch({ type: 'SEND_DATA', payload: { name, data, query } });
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
